import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=652748f1&scoped=true&"
import script from "./LoginRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652748f1",
  null
  
)

export default component.exports